import * as React from "react"

function SucursalIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.85 15.08"
      {...props}
    >
      <g data-name="Capa 2">
        <path
          d="M12.2 11.88v.29a.62.62 0 01-1.24 0v-.29a.62.62 0 011.24 0m-2.44 0v.29a.62.62 0 01-1.24 0v-.29a.62.62 0 011.24 0m-2.43 0v.29a.61.61 0 01-.62.59.6.6 0 01-.62-.59v-.29a.6.6 0 01.62-.59.6.6 0 01.62.59m-2.44 0v.29a.62.62 0 01-1.24 0v-.29a.62.62 0 011.24 0m7.31-2.6v.28a.62.62 0 01-1.24 0v-.28a.62.62 0 011.24 0m-2.44 0v.28a.62.62 0 01-1.24 0v-.28a.62.62 0 011.24 0m-2.43 0v.28a.6.6 0 01-.62.59.6.6 0 01-.62-.59v-.28a.6.6 0 01.62-.59.6.6 0 01.62.59m-2.44 0v.28a.62.62 0 01-1.24 0v-.28a.62.62 0 011.24 0m1.49-5.5A.6.6 0 017 3.19h.31v-.3a.62.62 0 011.23 0v.3h.31a.6.6 0 01.62.59.6.6 0 01-.62.59h-.31v.29a.62.62 0 01-1.23 0v-.29H7a.6.6 0 01-.62-.59m7 10.12H2.46V5.81h1.18a1.81 1.81 0 001.85 1.75h4.87a1.81 1.81 0 001.85-1.75h1.18zM1.24 3.49h2.4v1.14h-2.4zm3.64-1.73a.59.59 0 01.61-.58h4.87a.59.59 0 01.61.58v4a.59.59 0 01-.61.58H5.49a.59.59 0 01-.61-.58zm9.73 2.87h-2.4V3.49h2.4zm.62 1.18a.6.6 0 00.62-.59V2.9a.6.6 0 00-.62-.58h-3v-.56A1.81 1.81 0 0010.36 0H5.49a1.81 1.81 0 00-1.85 1.76v.56h-3A.6.6 0 000 2.9v2.32a.6.6 0 00.62.59h.6v8.09h-.6a.6.6 0 00-.62.59.61.61 0 00.62.59h14.61a.61.61 0 00.62-.59.6.6 0 00-.62-.59h-.6V5.81z"
          fill="#003da6"
          data-name="Capa 1"
        />
      </g>
    </svg>
  )
}

export default SucursalIcon
